"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OUTLINE_BORDER_WIDTH = exports.INSET_ELEMENT_OUTLINE_OFFSET = exports.INPUT_PADDING_WITH_ICON = exports.INPUT_PADDING_VERTICAL_DEFAULT = exports.INPUT_PADDING_HORIZONTAL_DEFAULT = exports.INPUT_OUTLINE_WIDTH = exports.INPUT_BORDER_WIDTH = exports.INPUT_BORDER_RADIUS = exports.ICON_DISABLED_TOP_POSITION = void 0;
var _utils = require("@amzn/stencil-design-tokens/js/web/utils");
const OUTLINE_BORDER_WIDTH = exports.OUTLINE_BORDER_WIDTH = 2;
const INSET_ELEMENT_OUTLINE_OFFSET = exports.INSET_ELEMENT_OUTLINE_OFFSET = -2;
const INPUT_OUTLINE_WIDTH = exports.INPUT_OUTLINE_WIDTH = 1;
const INPUT_BORDER_WIDTH = exports.INPUT_BORDER_WIDTH = 1;
const INPUT_PADDING_HORIZONTAL_DEFAULT = exports.INPUT_PADDING_HORIZONTAL_DEFAULT = 16;
const INPUT_PADDING_VERTICAL_DEFAULT = exports.INPUT_PADDING_VERTICAL_DEFAULT = 8;
const INPUT_PADDING_WITH_ICON = exports.INPUT_PADDING_WITH_ICON = 36 + INPUT_PADDING_VERTICAL_DEFAULT;
const INPUT_BORDER_RADIUS = exports.INPUT_BORDER_RADIUS = (0, _utils.token)('dimensions.border.radius.100');
const ICON_DISABLED_TOP_POSITION = exports.ICON_DISABLED_TOP_POSITION = 11;